export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M9 5.75h-.75v12.5H9v1.5H6v-1.5h.75V5.75H6v-1.5h3v1.5ZM6 8.5H4a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h2V17H4a2 2 0 0 1-1.99-1.796L2 15V9a2 2 0 0 1 2-2h2v1.5Zm14.204-1.49A2 2 0 0 1 22 9v6a2 2 0 0 1-1.796 1.99L20 17H9v-1.5h11a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5H9V7h11l.204.01Z"/>
</svg>
`;
